import React, { useState } from "react";
import {
    View,
    Text,
    StyleSheet,
    TouchableOpacity,
    LayoutAnimation,
    Platform,
    UIManager,
    ScrollView,
} from "react-native";
import { useTranslation } from "react-i18next";
import { useThemeSettings } from "../../../ThemeProvider";
import { useTrackScreenTime } from "../../../analytics/useTrackScreenTime";
import { ROUTES } from "../../../shared/constants/routes";

if (Platform.OS === "android") {
    UIManager.setLayoutAnimationEnabledExperimental &&
        UIManager.setLayoutAnimationEnabledExperimental(true);
}

export default function TermsScreen() {
    useTrackScreenTime(ROUTES.TERMS);
    const { t } = useTranslation();
    const { theme } = useThemeSettings();
    const [openIndex, setOpenIndex] = useState<number | null>(0);

    const toggle = (index: number) => {
        LayoutAnimation.easeInEaseOut();
        setOpenIndex(openIndex === index ? null : index);
    };

    return (
        <View
            style={styles.container}
        >
            <ScrollView contentContainerStyle={{ paddingBottom: 60, marginTop: 20 }}
                showsVerticalScrollIndicator={Platform.OS === 'web'}>
                   {Array.from({ length: 19 }, (_, i) => i + 1).map((num) => {
                    const isOpen = openIndex === num;

                    return (
                        <View key={num} style={[styles.cardWrapper, { borderColor: theme.colors.greyBase }]}>
                            <TouchableOpacity
                                activeOpacity={0.8}
                                style={styles.cardHeader}
                                onPress={() => toggle(num)}
                            >
                                <Text style={[styles.question, { color: theme?.colors?.textPrimary }]}>{t(`screens.terms.title${num}`)}</Text>

                                <Text style={[styles.icon, { color: theme?.colors?.primary }]}>
                                    {isOpen ? "—" : "+"}
                                </Text>
                            </TouchableOpacity>

                            {isOpen && (
                                <View style={styles.answerWrapper}>
                                    <Text style={[styles.answer, { color: theme?.colors?.textPrimary }]}>{t(`screens.terms.content${num}`)}</Text>
                                </View>
                            )}
                        </View>
                    );
                })}
            </ScrollView>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        paddingHorizontal: 24,
        paddingTop: 20,
    },

    viewAll: {
        fontSize: 16,
        fontWeight: "500",
    },

    cardWrapper: {
        borderWidth: 1,
        borderColor: "rgba(140, 79, 87, 0.25)",
        borderRadius: 16,
        paddingHorizontal: 16,
        paddingVertical: 14,
        marginBottom: 16,
    },

    cardHeader: {
        flexDirection: "row",
        justifyContent: "space-between",
    },

    question: {
        fontSize: 14,
        fontWeight: "600",
        color: "#3A2F2F",
        width: "90%",
    },

    icon: {
        fontSize: 26,
        color: "#B56C6D",
        marginTop: -4,
    },

    answerWrapper: {
        marginTop: 12,
    },

    answer: {
        fontSize: 14,
        lineHeight: 20,
        color: "#4A3D3D", fontWeight: "400",
    },
});